module.exports = __webpack_public_path__ + "img/zxitemimg3.79c55fa9.png";